<template>

  <div class="col"></div>
  <div class="col text-center"><button class="btn btn-primary" @click="gotoOEM1Stop()">Go to OEM 1 Stop</button>
  </div>
  <div class="col"></div>

  <!-- <iframe :src="oemLink" style="width: 100%; height: 100vh; border: none;" title="OEM1 Stop"></iframe> -->
</template>
<script>
export default {
  name: "OEM1Stop",
  props: {
    // Define any props if needed
    make: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      oem1StopLink: 'https://www.oem1stop.com',
      oemLinks: [
        { "id": 1, "make": "Acura", "href": "/content/acura" },
        { "id": 2, "make": "Audi", "href": "/content/audi" },
        { "id": 3, "make": "BMW", "href": "https://www.bmwtechinfo.com/" },
        { "id": 4, "make": "Buick", "href": "/content/buick" },
        { "id": 5, "make": "Cadillac", "href": "/content/cadillac" },
        { "id": 6, "make": "Chevrolet", "href": "/content/chevrolet" },
        { "id": 7, "make": "Chrysler", "href": "/content/chrysler" },
        { "id": 8, "make": "Dodge", "href": "/content/dodge" },
        { "id": 9, "make": "Fiat", "href": "/content/fiat" },
        { "id": 10, "make": "Ford", "href": "/content/ford" },
        { "id": 11, "make": "Genesis", "href": "/content/genesis" },
        { "id": 12, "make": "GMC", "href": "/content/gmc" },
        { "id": 13, "make": "Honda", "href": "/content/honda" },
        { "id": 14, "make": "Hummer", "href": "/content/hummer" },
        { "id": 15, "make": "Hyundai", "href": "/content/hyundai" },
        { "id": 16, "make": "Infiniti", "href": "/content/infiniti" },
        { "id": 17, "make": "Isuzu", "href": "http://isuzusource.com/v2/index.php" },
        { "id": 18, "make": "Jaguar", "href": "/content/jaguar" },
        { "id": 19, "make": "Jeep", "href": "/content/jeep" },
        { "id": 20, "make": "Kia", "href": "/content/kia" },
        { "id": 21, "make": "Land Rover", "href": "/content/land-rover" },
        { "id": 22, "make": "Lexus", "href": "/content/lexus" },
        { "id": 23, "make": "Lincoln", "href": "/content/lincoln" },
        { "id": 24, "make": "Mazda", "href": "/content/mazda" },
        { "id": 25, "make": "Mercedes-Benz", "href": "/content/mercedes-benz" },
        { "id": 26, "make": "Mercury", "href": "/content/mercury" },
        { "id": 27, "make": "Mini", "href": "https://www.minitechinfo.com/" },
        { "id": 28, "make": "Mitsubishi", "href": "https://mitsubishitechinfo.com" },
        { "id": 29, "make": "Nissan", "href": "/content/nissan" },
        { "id": 30, "make": "Oldsmobile", "href": "/content/oldsmobile" },
        { "id": 31, "make": "Pontiac", "href": "/content/pontiac" },
        { "id": 32, "make": "Porsche", "href": "https://www.porsche.com/usa/accessoriesandservices/porscheservice/additionalinformation/" },
        { "id": 33, "make": "Ram", "href": "/content/ram" },
        { "id": 34, "make": "Rivian", "href": "/content/rivian" },
        { "id": 35, "make": "Saturn", "href": "/content/saturn" },
        { "id": 36, "make": "Scion", "href": "/content/scion" },
        { "id": 37, "make": "Subaru", "href": "/content/subaru" },
        { "id": 38, "make": "Suzuki", "href": "https://suzukipitstopplus.com/" },
        { "id": 39, "make": "Tesla", "href": "/content/tesla" },
        { "id": 40, "make": "Toyota", "href": "/content/toyota" },
        { "id": 41, "make": "Volkswagen", "href": "/content/volkswagen" },
        { "id": 42, "make": "Volvo", "href": "/content/volvo" }
      ]
    }
  },
  computed: {
    // Compute the link based on the make prop
    oemLink() {
      const foundLink = this.oemLinks.find(link => link.make.toLowerCase() === this.make.toLowerCase())
      if (foundLink) {
        if (foundLink.href.indexOf('http') === -1 && foundLink.href) {
          return this.oem1StopLink + foundLink.href
        } else if (foundLink.href.indexOf('http') !== -1) {
          return foundLink.href
        }
      }
      return this.oem1StopLink
    }
  },
  methods: {
    gotoOEM1Stop() {
      const link = this.oemLink
      if (link) {
        window.open(link, '_blank')
      } else {
        console.error('No valid OEM link found for make:', this.make)
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>